/*
 *
 * TimeSlotPage constants
 *
 */

import { getPractice } from "../../utils/practiceStorage";

export const ADD_BEFORE = 1;
export const REMOVE_BEFORE = 2;
export const ADD_AFTER = 3;
export const REMOVE_AFTER = 4;

const scope = "app/TimeSlotPage/";

/**
 * Get TimeSlot
 */
export const GET_TIME_SLOT = "app/TimeSlotPage/GET_TIME_SLOT";
export const GET_TIME_SLOT_SUCCESS = "app/TimeSlotPage/GET_TIME_SLOT_SUCCESS";
export const GET_TIME_SLOT_FAILED = "app/TimeSlotPage/GET_TIME_SLOT_FAILED";

/**
 * Delete TimeSlot
 */
export const DELETE_TIME_SLOT = "app/TimeSlotPage/DELETE_TIME_SLOT";
export const DELETE_TIME_SLOT_SUCCESS =
  "app/TimeSlotPage/DELETE_TIME_SLOT_SUCCESS ";
export const DELETE_TIME_SLOT_FAILED =
  "app/TimeSlotPage/DELETE_TIME_SLOT_FAILED";

export const DEFAULT_ACTION = "app/TimeSlotPage/DEFAULT_ACTION";

/**
 * Delete appointment
 */
export const DELETE_APPOINTMENT = "app/TimeSlotPage/DELETE_APPOINTMENT";
export const DELETE_APPOINTMENT_SUCCESS =
  "app/TimeSlotPage/DELETE_APPOINTMENT_SUCCESS";
export const DELETE_APPOINTMENT_FAILED =
  "app/TimeSlotPage/DELETE_APPOINTMENT_FAILED";

// reset Loaders on unmount.
export const RESET_LOADING = "app/TimeSlotPage/RESET_LOADING";

/**
 * other
 */
export const MODIFY_TIME_SLOT = "app/TimeSlotPage/MODIFY_TIME_SLOT";
export const MODIFY_TIME_SLOT_SUCCESS =
  "app/TimeSlotPage/MODIFY_TIME_SLOT_SUCCESS ";
export const MODIFY_TIME_SLOT_FAILED =
  "app/TimeSlotPage/MODIFY_TIME_SLOT_FAILED";
export const CLEAR_MODIFY_TIME_SLOT_FAILED =
  "app/TimeSlotPage/CLEAR_MODIFY_TIME_SLOT_FAILED";

/**
 * Planned day
 */
export const GET_PLANNED_DAYS = `${scope}GET_PLANNED_DAYS`;
export const GET_PLANNED_DAYS_SUCCESS = `${scope}GET_PLANNED_DAYS_SUCCESS`;
export const GET_PLANNED_DAYS_FAILED = `${scope}GET_PLANNED_DAYS_FAILED`;

/**
 * Move treatment
 */
export const MOVE_TREATMENT = `${scope}MOVE_TREATMENT`;
export const MOVE_TREATMENT_SUCCESS = `${scope}MOVE_TREATMENT_SUCCESS`;
export const MOVE_TREATMENT_FAILED = `${scope}MOVE_TREATMENT_FAILED`;

/**
 * Urls
 */
export function MOVE_TREATMENT_URL(treatmentId) {
  return `/practices/${getPractice().id}/plannedTreatments/${treatmentId}`;
}

export function GET_PLANNED_DAYS_URL(date) {
  const formatted = date.format("YYYY-MM-DD");
  return `/practices/${getPractice().id}/plannedDay?date=${formatted}`;
}

export function MODIFY_TIME_SLOT_URL(ptsId, actionId) {
  return `/practices/${
    getPractice().id
  }/plannedTimeSlots/${ptsId}/actionType/${actionId}`;
}

export function DELETE_APPOINTMENT_URL() {
  return `/practices/${getPractice().id}/plannedTreatments`;
}

export function GET_TIME_SLOT_URL(timeSlotId) {
  return `/practices/${getPractice().id}/plannedTimeSlots/${timeSlotId}`;
}
export function DELETE_TIME_SLOT_URL() {
  return `/practices/${getPractice().id}/plannedTimeSlots`;
}
